<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE PARÂMETROS WHATSAPP'"
      showClearButton
      showSaveButton
      @Clear="onClear"
      @Save="onSave"
    >
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group col-md-12 row">
              <div class="col-md-8 pt-2">
                <label for="txtName">Provedor:</label>
                <div class="input-group">
                  <b-form-select v-model="form.provedor.value" :options="form.provedor.options">
                    <template slot="first">
                      <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                    </template>
                  </b-form-select>
                </div>
              </div>
              <div class="ml-2 col-md-2 pt-4 d-flex align-items-center">
                <b-form-checkbox @change="isChecked(form.isActive.value)" v-model="form.isActive.value" switch :value="true" :unchecked-value="false">
                  Ativo
                </b-form-checkbox>
              </div>
            </div>
            <div class="form-group col-md-12 row" v-if="form.provedor.value !== 'NXZAP'">
              <div class="col-md-6 pb-3">
                <label for="usuarioInput">
                  <small v-if="form.usuario.required" class="text-danger">*</small> Usuário:
                </label>
                <div class="input-group">
                  <b-form-input
                    type="text"
                    id="usuarioInput"
                    name="usuarioInput"
                    v-model="form.usuario.value"
                    :maxlength="form.usuario.maxlength"
                    :required="form.usuario.required"
                    :state="form.usuario.state"
                    class="w-100"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label for="senhaInput">
                  <small v-if="form.senha.required" class="text-danger">*</small> Senha:
                </label>
                <div class="input-group">
                  <b-form-input
                    type="password"
                    id="senhaInput"
                    name="senhaInput"
                    v-model="form.senha.value"
                    :maxlength="form.senha.maxlength"
                    :required="form.senha.required"
                    :state="form.senha.state"
                    class="w-100"
                  />
                </div>
              </div>
            </div>
            <div class="form-group col-md-12 row" v-if="form.provedor.value !== 'NXZAP'">
              <div class="col-md-12">
                <label for="urlInput">
                  <small v-if="form.url.required" class="text-danger">*</small> URL de Disparo:
                </label>
                <div class="input-group">
                  <b-form-input
                    type="text"
                    id="urlInput"
                    name="urlInput"
                    v-model="form.url.value"
                    :maxlength="form.url.maxlength"
                    :required="form.url.required"
                    :state="form.url.state"
                    class="w-100"
                  />
                </div>
              </div>
            </div>
            <div class="form-group col-md-12 row" v-if="form.provedor.value !== 'NXZAP'">
              <div class="col-md-12">
                <label for="urlInputLogin">
                  <small v-if="form.urlLogin.required" class="text-danger">*</small> URL de Login:
                </label>
                <div class="input-group">
                  <b-form-input
                    type="text"
                    id="urlInputLogin"
                    name="urlInputLogin"
                    v-model="form.urlLogin.value"
                    :maxlength="form.urlLogin.maxlength"
                    :required="form.urlLogin.required"
                    :state="form.urlLogin.state"
                    class="w-100"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="form.provedor.value !== 'NXZAP'">
            <div class="form-group col-md-12 row">
              <div class="col-md-12">
                <label>Body da Requisição:</label>
                <div class="nxbr-toolbar">
                  <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                      <i class="fas fa-address-card text-third"/>
                    </template>
                    <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOption('@CELULAR@', 'templateText')">Celular</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOption('@NOME@', 'templateText')">Nome</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOption('@PROTOCOLO@', 'templateText')">Protocolo</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOption('@HSM_ID@', 'templateText')">Id HSM</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOption('@HSM_VARIABLES@', 'templateText')">Variáveis HSM</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOption('@MODELO@', 'templateText')">Modelo</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.prevent="onAddingOption('@NOME_GERENTE@', 'templateText')">Nome do Gerente</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="input-group">
                  <b-form-textarea
                    v-model="form.body.value"
                    ref="templateText"
                    :placeholder="JSON.stringify(this.jsonData, null, 2)"
                    :rows="form.body.rows"
                    :size="form.body.maxlength"
                    :noResize="true">
                  </b-form-textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Forms>
  </div>
</template>

<script>
import ParametroWhatsappRepository from '@/shared/http/repositories/configurations/parametroDisparoWhatsapp.js'

import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

const viewbForm = {
  usuario: {
    value: '',
    maxlength: '100',
    required: true,
    state: null
  },
  senha: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  url: {
    value: null,
    maxlength: '100',
    required: true,
    state: null
  },
  urlLogin: {
    value: null,
    maxlength: '100',
    required: true,
    state: null
  },
  isActive: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  body: {
    value: '',
    maxlength: '160',
    required: true,
    state: null,
    rows: 13,
    size: 500
  },
  provedor: {
    value: null,
    options: [
      {
        text: 'DIGITALK',
        value: 'DIGITALK'
      },
      {
        text: 'NXZAP',
        value: 'NXZAP'
      },
      {
        text: 'UBOTS',
        value: 'UBOTS'
      }
    ]
  }
}

const viewbData = {
  id: 1,
  usuario: null,
  senha: null,
  url: null,
  urlLogin: null,
  isActive: null,
  body: null,
  provedor: null
}

export default {
  name: 'WhatsappParams',
  mixins: [ActionsForm],
  data () {
    return {
      form: viewbForm,
      data: viewbData,
      toolbars: {
        bold: false,
        italic: false,
        header: false,
        underline: false,
        strikethrough: false,
        mark: false,
        superscript: false,
        subscript: false,
        quote: false,
        ol: false,
        ul: false,
        link: false,
        imagelink: false,
        code: false,
        table: false,
        fullscreen: false,
        readmodel: false,
        htmlcode: false,
        help: false,
        undo: false,
        redo: false,
        trash: false,
        save: false,
        navigation: false,
        alignleft: false,
        aligncenter: false,
        alignright: false,
        subfield: false,
        preview: false
      },
      jsonData: {
        'phone': 'phone_number_formatado',
        'template_message_id': 'id_do_modelo',
        'variables': '{"1":"nome_do_cliente"}',
        'type': 'text',
        'ia': false,
        'id_department': 'id_do_departamento',
        'id_channel': 2,
        'international': false
      }
    }
  },
  watch: {
    'form.provedor.value': function (newValue) {
      if (newValue === 'NXZAP') {
        this.form.usuario.value = 'defaultUser'
        this.form.senha.value = 'defaultPassword'
        this.form.url.value = 'https://default.url'
        this.form.urlLogin.value = 'https://default.login.url'
        this.form.body.value = 'defaultBody'
      }
    }
  },
  methods: {
    async onLoad () {
      try {
        const response = await ParametroWhatsappRepository.GetParams()
        if (response.status === 200) {
          this.onEdit(response.data)
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    async onCreate () {
      try {
        loading.push()

        this.data.id = parseInt(this.data.id)
        const response = await ParametroWhatsappRepository.Create(this.data)
        if (response.status === 201) {
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      } finally {
        loading.pop()
      }
    },
    async onUpdate () {
      try {
        const response = await ParametroWhatsappRepository.UpdateParams(this.data)
        if (response.status === 200) {
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      } finally {
        loading.pop()
      }
    },
    onAddingOption (value, location) {
      if (location === 'templateText') {
        this.form.body.value = this.form.body.value + value + ' '
        this.$refs.templateText.focus()
      }
      return false
    }
  }
}
</script>
<style scoped>
.input-group-addon{
  z-index: 9999;
}
.mavonEditor {
  border: solid 1px #ccc;
  min-width: 100%;
  min-height: 543px;
  max-height: 543px;
  overflow: scroll;
}
.v-note-wrapper.shadow {
  border: solid 1px #ccc;
}
.markdown-body>:first-child {
  background-color: #eceff1 !important;
  border-bottom: solid 1px #cfd8dc;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon,
.v-note-wrapper .v-note-op .v-right-item .op-icon {
  color: #006a5b !important;
}
.v-note-wrapper .v-note-op .v-left-item .op-icon.selected,
.v-note-wrapper .v-note-op .v-right-item .op-icon.selected {
  color: #006a5b !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon:hover,
.v-note-wrapper .v-note-op .v-right-item .op-icon:hover {
  color: #005c50 !important;
  font-weight: 800;
}

.v-note-wrapper .v-note-op .v-left-item .op-icon button, .v-note-wrapper .v-note-op .v-right-item .op-icon button {
  color: #006a5b;
}
button.op-icon {
  color: #006a5b !important;
}
.nxbr-toolbar {
  background-color: #eceff1 !important;
  border-top: solid 1px #cfd8dc;
  border-left: solid 1px #cfd8dc;
  border-right: solid 1px #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/whatsapp/DisparoWhatsappParams.vue